module.exports = __webpack_public_path__ + "img/icon-page-footer-logo-canals5d.2e44a7ae.svg";